import React from 'react';

import AvatarIcon from 'assets/icons/avatar-icon.svg';

import classes from './UserImage.module.scss';

const UserImage = ({imageURL}) => {
    return (
        <div className={`${classes['user-avatar']}`}>
            {imageURL ? <img src={imageURL} alt="avatar" /> :
                (
                    <>
                        <div className={classes["default-avatar"]}>
                            <AvatarIcon />
                        </div>
                    </>
                )}
        </div>
    );
};

export default UserImage;